<comment>
訴求ポイントマーカー
座標とidをプロパティで受け取る
クリックでidを引数にfeatureMarkerClickをemit
</comment>

<template>
  <div>
    <span v-show="showFeatureMarker" class="feature-marker" @click="featureMarkerClick" :style="{top:y+'px', left:x+'px'}"></span>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'featureMarker',
  props: [
    "id","x","y"
  ],
  computed: mapState([
    'showFeatureMarker'
  ]),
  methods: {
    featureMarkerClick(){
      this.$emit('featureMarkerClick',this.id);
    }
  }
}
</script>

<style scoped lang="scss">
.feature-marker{
  position: absolute;
  top: -9999px;
  left: -9999px;
  box-shadow: 2px 2px 0 0 rgba(0, 49, 69, .3);
  display: block;
  width: 21px;
  height: 21px;
  background-image: url(../assets/image/fp_icon.png);
  transform: translate(-50%,-50%);
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
}
</style>